import StepFormTemplate from "../../templates/step-form.template.jsx";
import GeneralInformationTemplate from "../../templates/general-information.template.jsx";
import {useEffect, useState} from "react";
import {fetchLoanUsages, fetchUserOccupations} from "../../../services/new-services/public-v2.services.js";
import {useDispatch, useSelector} from "react-redux";
import {fetchUserRewardInfoAPI} from "../../../services/new-services/referrals.service.js";
import {
    updateGeneralInformation,
    updateReferralCode
} from "../../../redux/slices/application-process.slice.js";
import {useNavigate} from "react-router-dom";
import { toast } from "react-toastify";
import CredoAppSdkService from '../../../services/credoappsdk.services';
import { createWebLogRecord } from "../../../services/new-services/analytics.service.js";

export const ApplicationInitialStepScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userOccupations, setUserOccupations] = useState([]);
    const [loanUsages, setLoanUsages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const referralCode = useSelector(state => state.applicationProcess.referralCode);
    const sessionId = useSelector(state => state.applicationProcess.sessionId);
    const [selectedLoanUsage, setSelectedLoanUsage] = useState(null);
    const [selectedUserOccupation, setSelectedUserOccupation] = useState(null);
    const [localReferralCode, setLocalReferralCode] = useState('');
    const [submitEnabled, setSubmitEnabled] = useState(false);

    function handleInitialization() {
        CredoAppSdkService.startTracking();
        let userOccupations = fetchUserOccupations();
        let loanUsages = fetchLoanUsages();

        Promise.all([userOccupations, loanUsages])
            .then(([occupationsResponse, usagesResponse]) => {
                occupationsResponse.occupations.sort((a, b) =>
                    a.name === 'Otro'
                        ? 1
                        : b.name === 'Otro'
                            ? -1
                            : a.name.localeCompare(b.name),
                );
                usagesResponse.usages.sort((a, b) => a.name.localeCompare(b.name));
                setUserOccupations(occupationsResponse.occupations.map(occupation => ({
                    id: occupation.id,
                    value: occupation,
                    label: occupation.name
                })));
                setLoanUsages(usagesResponse.usages.map(usage => ({
                    id: usage.id,
                    value: usage,
                    label: usage.name
                })));
                setIsLoading(false);
            });
    }


    async function handleReferralCodeValidation() {
        if(![5, 10].includes(localReferralCode.length)) {
            toast.error('El código de referido debe tener 5 o 10 caracteres', { autoClose: 1500 });
        }else if (localReferralCode.length === 10 || localReferralCode.length === 5) {
            setIsLoading(true);
            fetchUserRewardInfoAPI(localReferralCode).then(res => {
                if (res.success) {
                    dispatch(updateReferralCode(localReferralCode));
                    createWebLogRecord(sessionId, null, 
                        { referralCode: localReferralCode }, false, true, 'USER_INPUT_REFERRAL_CODE');
                }else{
                    toast.error('El código de referido no es válido', { autoClose: 1500 });
                    createWebLogRecord(sessionId, null, 
                        { referralCode: localReferralCode }, true, false, 'USER_INPUT_REFERRAL_CODE');
                }
                setIsLoading(false);
            });
        }
        setIsLoading(false);
    }

    useEffect(() => {
        if (!!referralCode && !!selectedLoanUsage && !!selectedUserOccupation) {
            setSubmitEnabled(true);
        } else if (!referralCode && localReferralCode.length === 0 && !!selectedLoanUsage && !!selectedUserOccupation ) {
            setSubmitEnabled(true);
        }else{
            setSubmitEnabled(false);
        }
    }, [referralCode, localReferralCode, selectedLoanUsage, selectedUserOccupation]);

    useEffect(() => {
        handleInitialization();
    }, [])

    function handleSubmit() {
        dispatch(updateGeneralInformation({
            loanUsage: selectedLoanUsage,
            userOccupation: selectedUserOccupation,
        }));
        createWebLogRecord(sessionId, null, { 
            loanUsage: selectedLoanUsage, 
            userOccupation: selectedUserOccupation,
            referralCode: localReferralCode,
            }, false, true, 'USER_CLICK_COMPLETE_REQUEST',);
        navigate('/app/application/first-step');
    }

    return (
        <div style={styles.mainContainerStyle}>
            <StepFormTemplate
                title={'Información general'}
                description={'Cuéntanos un poco sobre ti'}
                currentStep={1}
                totalSteps={5}
                onSubmit={handleSubmit}
                submitEnabled={submitEnabled}
                onClose={() => {
                    navigate('/');
                }}
            >
                <GeneralInformationTemplate
                    isLoading={isLoading}
                    loanUsageOptions={loanUsages}
                    onLoanUsageSelection={setSelectedLoanUsage}
                    userOccupationOptions={userOccupations}
                    onUserOccupationSelection={setSelectedUserOccupation}
                    referralCodeValidated={referralCode !== null}
                    referralCode={localReferralCode}
                    onReferralCodeInput={setLocalReferralCode}
                    handleReferralCodeValidation={handleReferralCodeValidation}
                />
            </StepFormTemplate>
        </div>
    )
}


const styles = {
    mainContainerStyle: {
        margin: '0 auto',
        padding: window.innerWidth > 700 ? '0 25%' : '0'
    }
}